import inventoryTransferQueryApi from "../../../api/inventory/inventoryTransferQueryApi";
import {
  InventoryTransferFilter,
} from "../../../types/inventory/transfer/InventoryTransferTypes";

const InventoryTransferQueryService = {
  /**
   * 🔎 Obtiene traslados con filtros + paginación.
   * POST /api/inventory/transfers/query/filter?page=X&size=Y&sort=campo,asc
   */
  getFiltered: async (
    filter: InventoryTransferFilter,
    page = 0,
    size = 10,
    sort = "requestedAt,desc"
  ) => {
    const response = await inventoryTransferQueryApi.addCustom(
      `/filter?page=${page}&size=${size}&sort=${sort}`,
      filter
    );
    return response.data;
  },

  /**
   * 📦 Obtiene la cantidad de traslados PENDIENTES.
   * GET /api/inventory/transfers/query/pending-count
   */
  countPending: async () => {
    const response = await inventoryTransferQueryApi.fetchCustom(
      `/pending-count`
    );
    return response.data;
  },

  /**
   * 📄 Obtiene un traslado por ID.
   * GET /api/inventory/transfers/query/{id}
   */
  getById: async (id: number) => {
    const response = await inventoryTransferQueryApi.fetchCustom(`/${id}`);
    return response.data;
  },

  /**
   * 🔍 Búsqueda rápida de traslados activos
   * GET /api/inventory/transfers/query/search?q=VALUE
   */
  searchActiveTransfers: async (query: string) => {
    const response = await inventoryTransferQueryApi.fetchCustom(
      `/search?q=${encodeURIComponent(query)}`
    );
    return response.data;
  },

  /**
   * 🟦 Listado simple de traslados pendientes (REQUESTED + APPROVED)
   * GET /api/inventory/transfers/query/pending
   */
  getPendingTransfers: async () => {
    const response = await inventoryTransferQueryApi.fetchCustom(`/pending`);
    return response.data;
  },
};

export default InventoryTransferQueryService;
